<template>
  <div :class="[$style.wrapper, small && $style.small]" @mouseout="$emit('mouseout')" @mouseover="$emit('mouseover')">
    <div :class="$style.info">
      <img :src="avatar" :class="$style.avatar" :alt="name"/>
      <template v-if="small || $mq === 'sm'">
        <div>
          <div :class="$style.name">{{ name }}</div>
          <div :class="$style.age">{{ age }}</div>
        </div>
      </template>
      <template v-else>
        <div :class="$style.name">{{ name }}</div>
        <div :class="$style.age">{{ age }}</div>
      </template>
    </div>
    <div :class="$style.interests">
      <div v-if="!small">Интересы</div>
      <div :class="$style.interests__container">
        <div v-for="(interest, id) in interests" :key="`interest-${random()}-${id}`"
             :style="{backgroundImage: `url('${interest.src}')`, backgroundColor: interest.selected || interest.bgFixed ? '#1BC54A' : '#F5F5F5' }"
             :class="$style.interests__item"
             class="pointer"
             @click="interestSelect(id)"
        >
          <div :class="$style.tooltip">{{ interest.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InterestCard',
  props: {
    avatar: String,
    name: String,
    age: String,
    interests: Array,
    fixedInterests: Array,
    small: Boolean,
  },
  data() {
    return {
      showTooltip: false,
    }
  },
  methods: {
    interestSelect(id) {
      if (this.fixedInterests && this.fixedInterests.find(item => item === id)) return
      this.$emit('interestSelected', id)
    },
    random() {
      return Math.round(Math.random() * 1000)
    },
  },
}
</script>

<style lang="scss" module>
.wrapper{
  background-color: #fff;
  color: #000;
  box-shadow: 0px 2.37363px 11.8681px rgba(0, 0, 0, 0.15), 0px 1.18681px 2.37363px rgba(0, 0, 0, 0.2);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  padding: 2.4rem 4.2rem 2.4rem 2.4rem;

  @media #{$m-mobile} {
    padding: 1.5rem;
    border-radius: 2rem;
  }
  .info{
    display: flex;
    flex-direction: column;
    .avatar{
      width: 11.9rem;
      height: 11.9rem;
      @media #{$m-mobile} {
        width: 6rem;
        height: 6rem;
        margin-right: 1rem;
      }
    }
    @media #{$m-mobile} {
      flex-direction: row;
    }
    .name {
      margin-top: .6rem;
      font-size: 2.9rem;
      font-weight: 400;

      @media #{$m-mobile} {
        font-size: 1.8rem;
      }
    }
    .age {
      font-size: 2.2rem;
      color: #808080;

      @media #{$m-mobile} {
        font-size: 1.5rem;
      }
    }
  }
  .interests{
    margin-top: 2.4rem;
    font-size: 1.7rem;

    @media #{$m-mobile} {
      margin-top: 1rem;
      font-size: 1.2rem;
    }
    &__container{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    &__item{
      position: relative;
      margin-top: 2.2rem;
      width: 5.7rem;
      height: 5.7rem;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 64%;
      border-radius: 50%;
      max-width: 33%;
      transition: background-color .4s;
      @media #{$m-mobile} {
        width: 5.4rem;
        height: 5.4rem;
        margin-top: 1.2rem;
      }
      .tooltip{
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -130%);
        background: #000;
        color: white;
        white-space: nowrap;
        padding: 1.2rem;
        border-radius: 1rem;
        visibility: hidden;
        opacity: 0;
        transition: opacity .6s;
        &:after{
          content: "";
          position: absolute;
          top: 75%;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 20px solid transparent;
          border-right: 20px solid transparent;
          border-top: 20px solid #000;
          font-size: 1.4rem;
        }
      }
      /*img{
        &:hover{
          box-shadow: 0 0 1rem 1rem #00000011;
        }
      }*/
      &:hover{
        box-shadow: 0 0 0 2px $color-green;
        .tooltip{
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }
}

@media #{$m-mobile} {
  .wrapper:not(.small) {
    .info {
      .name {
        font-size: 1.4rem;
      }

      .age {
        font-size: 1.2rem;
      }

      .avatar {
        width: 4rem;
        height: 4rem;
      }
    }
  }
}

.small {
  padding: 2rem;

  .info {
    flex-direction: row;
    align-items: flex-end;

    @media #{$m-mobile} {
      align-items: center;
    }

    .avatar{
      width: 8rem;
      height: 8rem;
      margin-right: 2rem;

      @media #{$m-mobile} {
        margin-right: 1rem;
        width: 6rem;
        height: 6rem;
      }
    }

  }

  .interests__container {
    margin-top: 1.5rem;
    justify-content: flex-start;
  }

  .interests__item {
    margin-top: 0;

    & + .interests__item {
      margin-left: 1.5rem;
    }
  }
}
</style>
